// Path in repo: src/pages/organization-dashboard/components/analytics/EnrollmentByCategory.jsx

import React from "react"
import { formatCompactNumber } from "../../../../utils/formatters"
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "../../../../components/ui/card"
import {
  ShareBarList, ShareBarListContent, ShareBarListFill,
  ShareBarListItem, ShareBarListLabel, ShareBarListValue,
} from "../../../../components/share-bar-list"

const FALLBACK_ROWS = [
  { label: "Compliance", enrollments: 2140 },
  { label: "Technology", enrollments: 1580 },
  { label: "Business skills", enrollments: 940 },
  { label: "Certifications", enrollments: 610 },
  { label: "Other", enrollments: 260 },
]

const EnrollmentByCategory = ({ rows }) => {
  const data = rows?.length ? rows : FALLBACK_ROWS
  const max = Math.max(...data.map((d) => d.enrollments), 1)

  return (
    <Card className="dark:bg-transparent">
      <CardHeader className="border-b pb-4">
        <CardTitle>Enrollment by category</CardTitle>
        <CardDescription>Last 12 months</CardDescription>
      </CardHeader>
      <CardContent className="p-0 py-1">
        <ShareBarList>
          {data?.map((row) => (
            <ShareBarListItem key={row?.label} value={(row?.enrollments / max) * 75}>
              <ShareBarListContent>
                <ShareBarListLabel>{row?.label}</ShareBarListLabel>
                <ShareBarListValue>{formatCompactNumber(row?.enrollments)}</ShareBarListValue>
              </ShareBarListContent>
              <ShareBarListFill />
            </ShareBarListItem>
          ))}
        </ShareBarList>
      </CardContent>
    </Card>
  )
}

export default EnrollmentByCategory